var React = require('react');

function RecordOff (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"7","stroke":"currentColor","strokeWidth":"2","fill":"none","key":0}),React.createElement("circle",{"cx":"12","cy":"12","r":"4","fill":"currentColor","key":1})]);
}

RecordOff.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = RecordOff;

RecordOff.default = RecordOff;
